import * as api from '../api';


export const WakeUp = () => {
    // Ping the backend to wake it up from sleep mode
    return new Promise((resolve, reject) => {
        api
            .get('/utils/')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};

export const GetEconomicCalendar = () => {
    return new Promise((resolve, reject) => {
        api
            .get('/utils/economic_calendar')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            })
    });
};
